import React from "react";
import PropTypes from "prop-types";
import { FormLabel, InputAdornment, withStyles } from '@material-ui/core';
import classNames from "classnames";
import CustomInput  from '../../CustomInput/CustomInput';
import Icon from '../Icon/Icon'
import IconResources from '../IconResources.jsx'
import customInputStyle from "../../../assets/jss/material-dashboard-pro-react/components/customInputStyle.jsx";

class FormInput extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: false
        };
    }

    validateInput = (e) => {
        if (!this.props.validated) {
            this.setState({ error: false });
            return;
        }

        if (this.props.handleInputValidation) {
            const value = e.target.value.trim();
            this.setState({ error: !this.props.handleInputValidation(value) });
        }
    }

    handleInputChange = (e) => {
        this.props.handleInputChange(e);

        if (this.props.validated) {
            this.validateInput(e);
        }
    }

    render() {
        const self = this;
        const { classes } = this.props;
        const { error } = this.state;
        const labelClass = classNames({
            [classes.labelRootError]: error,
        });

        const containerClass = `form-group-custom ${this.props.className}`;

        const inputProps = {
            placeholder: self.props.placeholder || '',
            onBlur: e => self.validateInput(e),
            onChange: e => self.handleInputChange(e),
            type: 'text',
            defaultValue: self.props.defaultValue,
            value: self.props.value
        };

        if (self.props.showAdornment) {
            inputProps.startAdornment =
                (
                    <InputAdornment
                        position='start'
                        className={classes.inputAdornment + ' search-icon'}
                    >
                        <Icon icon={IconResources.SEARCH} className={classes.inputAdornmentIcon} />
                    </InputAdornment>
                );
        }

        if (self.props.showClearIcon) {
            inputProps.endAdornment =
                (
                    <InputAdornment
                        position='end'
                        className={classes.inputAdornment + ' clear-icon'}
                        onClick={self.props.handleClearIconClick}
                    >
                        <Icon icon={IconResources.CROSS} className={classes.inputAdornmentIcon} />
                    </InputAdornment>
                );
        }

        return (
            <div className={containerClass}>
                {this.props.showLabel && <FormLabel className={labelClass} > {self.props.label} </FormLabel>}
                <CustomInput
                    success={!self.error}
                    error={self.error}
                    formControlProps={{ fullWidth: true }}
                    inputProps={inputProps}
                />
            </div>
        );
    };
}


FormInput.defaultProps = {
    showLabel: true,
    validated: true,
    className: ''
};

FormInput.propTypes = {
    classes: PropTypes.object.isRequired,
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    defaultValue: PropTypes.string.isRequired,
    handleInputChange: PropTypes.func.isRequired,

    validated: PropTypes.bool,
    placeholder: PropTypes.string,
    showLabel: PropTypes.bool,
    showAdornment: PropTypes.bool,
    showClearIcon: PropTypes.bool,
    className: PropTypes.string,
    handleInputValidation: PropTypes.func,
    handleClearIconClick: PropTypes.any
};

export default withStyles(customInputStyle)(FormInput);